<!-- 咨询提交成功页面 -->
<template>
  <div class="column_flex successWrap">
    <OssImg src="images/homeIcon15.png" alt="" />
    <div>提交成功</div>
    <el-button @click="navTo('/home')" type="success" style="width: 60%"
      >回到首页</el-button
    >
    <div class="bottomTip">
      如果您现在就需要帮助，可立即拨打400-966-5960与我们联系！
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { navTo } from "@/utils/util";
</script>

<style lang="scss" scoped>
.successWrap {
  margin-top: 3.5rem;
  img {
    width: 6.25rem;
    height: 6.25rem;
    margin-bottom: 1.5rem;
  }

  > div:first-of-type {
    color: #424242;
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 2.125rem;
    margin-bottom: 1.5rem;
  }
}

.bottomTip {
  width: 100%;
  color: #424242;
  font-family: "PingFang SC";
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  margin: 3rem auto 9.3125rem;
}
</style>
